// @flow

import alt from '../alt';

class DiagnosticsActions {
	/**
	 * Algatatakse laadimine serverist
	 */
	fetch() {
		return {};
	}
	
	/**
	 * Laadimine ebaõnnestus
	 */
	fetchFailed(error) {
		return error;
	}
	
	/**
	 * Sai laetud
	 */
	fetchDone(data) {
		return data;
	}
}

export default alt.createActions(DiagnosticsActions);
